<template>
  <v-app>
    <v-layout row justify-center>
      <v-dialog
        v-model="isLoading"
        persistent
        fullscreen
        content-class="loading-dialog"
      >
        <v-container fill-height>
          <v-layout row justify-center align-center>
            <v-progress-circular
              class="spinner"
              indeterminate
              :size="70"
              :width="7"
              color="primary"
            ></v-progress-circular>
          </v-layout>
        </v-container>
      </v-dialog>
    </v-layout>
  </v-app>
</template>

<script>
export default {
  props: ['isLoading'],
};
</script>

<style lang="sass">
.loading-dialog
  background-color: rgba(255, 255, 255, 0.5)
.spinner
  z-index: 99999
</style>
